export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10043.6b524b2f.jpg";